{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "forge",
  "roles": [
    "director-of-maintenance",
    "accountable-manager",
    "tenant-administrator"
  ],
  "orgTypes": [
    "part-135",
    "part-145",
    "oem-service",
    "integrated-135-145",
    "management-company"
  ],
  "extensions": [
    "byom",
    "co-build",
    "ironfleet-network",
    "integrations",
    "workflow-extensions",
    "data-migration"
  ],
  "integrations": []
}